var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"className":"News Wrapper h-100"}},[_c('NewsTemplate',{attrs:{"newsID":_vm.id,"src":_vm.src,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }